// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SmallNotice__root--A9CU {
    display: grid;
    grid-template-columns: 24px auto;
    align-items: center;
    grid-gap: 8px;
    margin-bottom: 16px;
}

    .SmallNotice__root--A9CU.SmallNotice__withBorder--diDB {
        padding: 16px;
        border: 1px solid var(--warning-color);
        border-radius: 6px;
    }

.SmallNotice__description--_O6d {
    color: var(--secondary-color);
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
}

.SmallNotice__description--_O6d > strong {
        font-weight: 700;
    }

.SmallNotice__icon--j60H {
    width: 24px;
    height: 24px;
}

.SmallNotice__icon--j60H.SmallNotice__info--rp0P {
        color: var(--warning-color);
    }

.SmallNotice__icon--j60H.SmallNotice__alert--Y9Fq,
    .SmallNotice__icon--j60H.SmallNotice__alertTriangle--FL87 {
        color: var(--error-color);
    }

.SmallNotice__icon--j60H.SmallNotice__checkedRound--GcZh {
        color: var(--success-color);
    }
`, "",{"version":3,"sources":["webpack://./src/ui/components/SmallNotice/SmallNotice.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,gCAAgC;IAChC,mBAAmB;IACnB,aAAa;IACb,mBAAmB;AAOvB;;IALI;QACI,aAAa;QACb,sCAAsC;QACtC,kBAAkB;IACtB;;AAGJ;IACI,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AAKrB;;AAHI;QACI,gBAAgB;IACpB;;AAGJ;IACI,WAAW;IACX,YAAY;AAchB;;AAZI;QACI,2BAA2B;IAC/B;;AAEA;;QAEI,yBAAyB;IAC7B;;AAEA;QACI,2BAA2B;IAC/B","sourcesContent":[".root {\n    display: grid;\n    grid-template-columns: 24px auto;\n    align-items: center;\n    grid-gap: 8px;\n    margin-bottom: 16px;\n\n    &.withBorder {\n        padding: 16px;\n        border: 1px solid var(--warning-color);\n        border-radius: 6px;\n    }\n}\n\n.description {\n    color: var(--secondary-color);\n    font-size: 12px;\n    font-weight: 400;\n    line-height: 16px;\n\n    > strong {\n        font-weight: 700;\n    }\n}\n\n.icon {\n    width: 24px;\n    height: 24px;\n\n    &.info {\n        color: var(--warning-color);\n    }\n\n    &.alert,\n    &.alertTriangle {\n        color: var(--error-color);\n    }\n\n    &.checkedRound {\n        color: var(--success-color);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `SmallNotice__root--A9CU`,
	"withBorder": `SmallNotice__withBorder--diDB`,
	"description": `SmallNotice__description--_O6d`,
	"icon": `SmallNotice__icon--j60H`,
	"info": `SmallNotice__info--rp0P`,
	"alert": `SmallNotice__alert--Y9Fq`,
	"alertTriangle": `SmallNotice__alertTriangle--FL87`,
	"checkedRound": `SmallNotice__checkedRound--GcZh`
};
export default ___CSS_LOADER_EXPORT___;
